import { useEffect, useRef, useState, ReactNode } from 'react';

interface LazyLoadSectionProps {
  children: ReactNode;
  threshold?: number;
  rootMargin?: string;
  minHeight?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const LazyLoadSection = ({ 
  children, 
  threshold = 0.1, 
  rootMargin = '200px', 
  minHeight,
  className = '',
  style
}: LazyLoadSectionProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // If IntersectionObserver is not supported, show immediately
    if (!('IntersectionObserver' in window)) {
      setIsVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold, rootMargin }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [threshold, rootMargin]);

  return (
    <div ref={ref} style={{ ...(minHeight ? { minHeight } : {}), ...style }} className={className}>
      {isVisible ? children : null}
    </div>
  );
};
